import type { ReactNode } from "react";
import { cn } from "@/lib/utils/classnames";

/**
 * The contextual top bar of a shell page: breadcrumb + title on the left, page
 * actions on the right (Run now, Resume, Share, New key, …). Sticky within the
 * content area so it stays put as the page scrolls. Pages render this instead of
 * the legacy AppHeader (which is now a no-op inside the shell).
 */
export function PageHeader({
  title,
  breadcrumb,
  actions,
  className,
}: {
  title: ReactNode;
  breadcrumb?: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <header
      className={cn(
        // h-14 + border-b on the header ITSELF (border-box), so its bottom border lands
        // at the same pixel as the ribbon's h-14 header border — a clean, continuous
        // seam across the ribbon↔content divide.
        "sticky top-0 z-30 flex items-center gap-3 h-14 px-6 border-b border-border bg-background/85 backdrop-blur-sm",
        className,
      )}
    >
      <div className="min-w-0 flex-1">
        {breadcrumb && (
          <div className="text-xs text-muted-foreground truncate">{breadcrumb}</div>
        )}
        <h1 className="text-sm font-semibold tracking-tight text-foreground truncate">
          {title}
        </h1>
      </div>
      {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
    </header>
  );
}
